import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, FolderTree, Receipt, MessageSquare, Settings, LogOut, Home as HomeIcon } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 tracking-eyebrow text-[0.72rem] border-l-2 transition-colors ${
      isActive
        ? "border-[var(--eafg-copper)] text-[var(--eafg-copper)] bg-white"
        : "border-transparent text-[#a8a29e] hover:text-white"
    }`;

  return (
    <div className="min-h-screen bg-[#fafaf9] grid grid-cols-1 md:grid-cols-[260px_1fr]" data-testid="admin-layout">
      <aside className="bg-[#1c1917] text-[#f8f7f5] md:min-h-screen flex flex-col">
        <div className="px-6 py-8 border-b border-[#44403c]">
          <Link to="/" className="font-serif-display text-2xl leading-tight">
            Esmalte <span className="italic text-[var(--eafg-copper-light)]">al fuego</span>
          </Link>
          <p className="tracking-eyebrow text-[#a8a29e] mt-2 text-[0.7rem]">Admin · {user?.email}</p>
        </div>
        <nav className="py-4 flex-1">
          <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-dashboard">
            <LayoutDashboard size={16} strokeWidth={1.5} /> {t("admin.dashboard")}
          </NavLink>
          <NavLink to="/admin/productos" className={linkClass} data-testid="admin-nav-products">
            <Package size={16} strokeWidth={1.5} /> {t("admin.products")}
          </NavLink>
          <NavLink to="/admin/categorias" className={linkClass} data-testid="admin-nav-categories">
            <FolderTree size={16} strokeWidth={1.5} /> {t("admin.categories")}
          </NavLink>
          <NavLink to="/admin/pedidos" className={linkClass} data-testid="admin-nav-orders">
            <Receipt size={16} strokeWidth={1.5} /> {t("admin.orders")}
          </NavLink>
          <NavLink to="/admin/contactos" className={linkClass} data-testid="admin-nav-contacts">
            <MessageSquare size={16} strokeWidth={1.5} /> {t("admin.contacts")}
          </NavLink>
          <NavLink to="/admin/ajustes" className={linkClass} data-testid="admin-nav-settings">
            <Settings size={16} strokeWidth={1.5} /> {t("admin.settings")}
          </NavLink>
        </nav>
        <div className="px-4 py-6 border-t border-[#44403c] space-y-3">
          <Link to="/" className="flex items-center gap-2 tracking-eyebrow text-[#a8a29e] hover:text-white text-[0.72rem]">
            <HomeIcon size={14} strokeWidth={1.5} /> {t("nav.home")}
          </Link>
          <button
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="flex items-center gap-2 tracking-eyebrow text-[#a8a29e] hover:text-white text-[0.72rem]"
            data-testid="admin-logout"
          >
            <LogOut size={14} strokeWidth={1.5} /> {t("nav.logout")}
          </button>
        </div>
      </aside>
      <section className="p-6 md:p-12">
        <Outlet />
      </section>
    </div>
  );
}
